import { Component, ElementRef, ViewChild } from '@angular/core';
import { DashboardService } from '../services/dashboard.service';
import { NotificationService } from '../services/notification.service';
import { AuthService } from '../core/auth-service';
import { Chart, registerables } from 'chart.js';
import { GridStack, GridStackOptions } from 'gridstack';


@Component({
  selector: 'app-dashboard2',
  templateUrl: './dashboard2.component.html',
  styleUrl: './dashboard2.component.scss'
})
export class Dashboard2Component {
  constructor(private dashboardService: DashboardService, private notificationService: NotificationService, private authService: AuthService
  ) { }
  @ViewChild('gridContainer', { static: true }) gridContainer!: ElementRef;
  // loading: boolean;
  defaultPeriodType: string = 'WTD';
  buyerName: string;
  username: string;
  grid: GridStack;
  resizeObserver: ResizeObserver;
  cardIds = [
    'conversion-target',
    'cosmetic-grade-match',
    'mechanical-grade-match',
    'avg-time-to-purchase',
    'faster-payment',
    'customer-score',
  ];

  async ngOnInit(): Promise<void> {
    Chart.register(...registerables);

    const options: GridStackOptions = {
      disableResize: true,
      disableDrag: true,
      sizeToContent: false,
      cellHeight: 250,
      margin: 6,
      float: true,
      staticGrid: true,
      columnOpts: {
        columnWidth: 350,
        columnMax: 3,
      },
    };
    this.grid = GridStack.init(options, this.gridContainer.nativeElement);


    this.username = this.authService.getUser().username.split('@')[0];
    this.buyerName = this.authService.getUser()?.name;
  }

  ngAfterViewInit(): void {

    document.documentElement.scrollTo(1, 1);
    this.resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        const width = entry.contentRect.width;
        setTimeout(() => {
          this.updateGridLayout(width);
        }, 200);
      }
    })

    this.resizeObserver.observe(this.gridContainer.nativeElement);

  }
  ngOnDestroy(): void {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  setPeriodType(periodType, isPreviousWeek) {
    this.defaultPeriodType = isPreviousWeek ? 'PW' : periodType;
    //let periodOffset = 0;
    //if (isPreviousWeek) periodOffset = -1;
  }

  updateGridLayout(width: number) {
    if (!this.grid) return;

    const columns = width < 680 ? 1 : width < 990 ? 2 : 3;
    this.grid.column(columns);

    this.grid.batchUpdate();

    this.cardIds.forEach((id, index) => {
      const el = document.querySelector(`[data-gs-id="${id}"]`) as HTMLElement;
      if (el) {
        this.grid.update(el, {
          x: index % columns,
          y: Math.floor(index / columns),
          w: 1,
          h: 1
        });
      }
    });
    this.grid.batchUpdate(false);
  }
}